export default __webpack_public_path__ + "static/dont-bg-a55d412f38cf7e40b7af6ed330442bf8.png";